import { useFileUpload } from './useFileUpload';
import { useCallback, useState } from 'react';

/**
 * DEPRECATED: Use useFileUpload instead
 * 
 * This hook maintains backward compatibility with the old useImageUpload API.
 * It wraps useFileUpload but limits to images only.
 * 
 * WHY: Existing code depends on useImageUpload, so we maintain the old API
 * while delegating to the new, more powerful useFileUpload hook.
 * This prevents breaking changes and allows gradual migration.
 * 
 * @returns {Object} - File upload state and handlers (images only)
 * @deprecated Use useFileUpload(['image']) instead
 */
export const useImageUpload = () => {
  // Use the new hook but limit to images only
  const {
    selectedFiles,
    totalUploadSize,
    error,
    handleFileSelect,
    removeFile,
    clearFiles,
  } = useFileUpload(['image']);

  // WHY: Track local error state for backward compatibility with clearError
  const [, setLocalError] = useState(null);

  // WHY: Provide clearError for backward compatibility
  const clearError = useCallback(() => {
    setLocalError(null);
  }, []);

  // Map new prop names to old ones for backward compatibility
  return {
    // Old API names (for existing code)
    selectedImages: selectedFiles,
    imagesTotalSize: totalUploadSize,
    imageError: error,
    handleImageSelect: handleFileSelect,
    removeImage: removeFile,
    clearImages: clearFiles,
    clearError,
    
    // Also expose new names for gradual migration
    selectedFiles,
    totalUploadSize,
    error,
    handleFileSelect,
    removeFile,
    clearFiles,
  };
};
